import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=729face6&scoped=true&lang=pug&"
import script from "./RecordList.vue?vue&type=script&lang=ts&"
export * from "./RecordList.vue?vue&type=script&lang=ts&"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=729face6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729face6",
  null
  
)

export default component.exports